import { render, staticRenderFns } from "./ChatBoxToggle.vue?vue&type=template&id=1b950ba8&scoped=true"
import script from "./ChatBoxToggle.vue?vue&type=script&lang=js"
export * from "./ChatBoxToggle.vue?vue&type=script&lang=js"
import style0 from "./ChatBoxToggle.vue?vue&type=style&index=0&id=1b950ba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b950ba8",
  null
  
)

export default component.exports